import { useState } from 'react'
import { Title } from '~/entities/BookingCar'
import { FullStories } from './FullStories'
import { SmallStories } from './SmallStories'
import { useLoadStories } from './useLoadStories'

export function Stories() {
  const [selectedStoryId, setSelectedStoryId] = useState<UniqueId | null>(null)

  const handleSmailStoryClick = (storyId: UniqueId) => {
    setSelectedStoryId(storyId)
  }
  const handleSelectedStoryIdReset = () => {
    setSelectedStoryId(null)
  }

  const { isFetching, data } = useLoadStories()

  if (!isFetching && !data?.length) return null

  return (
    <div data-testid='list-story-block'>
      <Title>Истории</Title>

      <SmallStories
        stories={data}
        onSlideClick={handleSmailStoryClick}
        isLoading={isFetching}
      />

      <FullStories
        stories={data}
        selectedStoryId={selectedStoryId}
        onClose={handleSelectedStoryIdReset}
      />
    </div>
  )
}
